import { openBlock as l, createElementBlock as o, createElementVNode as e } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M9.75 8.144a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0ZM8 7.894a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5Z",
  "clip-rule": "evenodd"
}, null, -1), c = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M8.279 1.304a.75.75 0 0 0-.558 0l-5 2A.75.75 0 0 0 2.25 4v6c0 .066.009.13.026.194.309 1.156 1.189 2.122 2.178 2.857 1.004.746 2.209 1.32 3.325 1.666a.752.752 0 0 0 .442 0c1.116-.345 2.321-.92 3.325-1.666.989-.735 1.869-1.701 2.179-2.857A.752.752 0 0 0 13.75 10V4a.75.75 0 0 0-.472-.696l-5-2Zm3.971 4.422V4.508L8 2.808l-4.25 1.7v1.218L7.536 4.21a1.25 1.25 0 0 1 .928 0l3.786 1.515ZM3.75 7.34v2.553c.182.577.635 1.168 1.299 1.718.117-.116.236-.217.35-.312.71-.591 1.647-.906 2.601-.906.955 0 1.892.315 2.602.906.113.095.233.196.35.311.664-.55 1.116-1.14 1.298-1.717V7.34L8 5.641l-4.25 1.7Zm5.92 5.135-.028-.024c-.416-.346-1.005-.558-1.642-.558-.636 0-1.225.212-1.64.558l-.029.024c.541.3 1.114.549 1.669.736a10.231 10.231 0 0 0 1.67-.736Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  n,
  c
];
function r(a, s) {
  return l(), o("svg", t, [...d]);
}
const p = { render: r };
export {
  p as default,
  r as render
};
